import { render, staticRenderFns } from "./DistroDialog.vue?vue&type=template&id=2426baf6&scoped=true"
import script from "./DistroDialog.vue?vue&type=script&lang=js"
export * from "./DistroDialog.vue?vue&type=script&lang=js"
import style0 from "./DistroDialog.vue?vue&type=style&index=0&id=2426baf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2426baf6",
  null
  
)

export default component.exports